<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout align-center row>
      <v-spacer />

      <v-tooltip
        v-if="hasRole('billing', 'ROLE_POST_CREATE_CREDIT')"
        top
        slot="activator"
        max-width="200px"
      >
        <v-btn
          :to="{ name: 'RideCredit', params: { type: 'cadastrar' } }"
          slot="activator"
          color="accent"
          class="action-bar__btn"
          round
          depressed
        >
          {{ $t(`${namespace}.addRideCredit`) }}
        </v-btn>
        <span>{{ $t(`${namespace}.addRideCreditTooltip`) }}</span>
      </v-tooltip>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Views.FinancialAdjustmentsPage',
      breadcrumbItems: [
        { title: this.$t('Views.FinancialPage.title') },
        { name: 'FinancialAdjustments', title: this.$t('Views.FinancialAdjustmentsPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>
